import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { CodeSnippet } from '@backstage/core-components';
import DialogContentText from '@material-ui/core/DialogContentText';
import { sortKeys } from './util.esm.js';
import { catalogReactTranslationRef } from '../../../translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

function JsonPage(props) {
  const { t } = useTranslationRef(catalogReactTranslationRef);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(DialogContentText, { variant: "h2", children: t("inspectEntityDialog.jsonPage.title") }),
    /* @__PURE__ */ jsx(DialogContentText, { children: t("inspectEntityDialog.jsonPage.description") }),
    /* @__PURE__ */ jsx(DialogContentText, { children: /* @__PURE__ */ jsx("div", { style: { fontSize: "75%" }, "data-testid": "code-snippet", children: /* @__PURE__ */ jsx(
      CodeSnippet,
      {
        text: JSON.stringify(sortKeys(props.entity), void 0, 2),
        language: "json",
        showCopyCodeButton: true
      }
    ) }) })
  ] });
}

export { JsonPage };
//# sourceMappingURL=JsonPage.esm.js.map
